import request from '@/utils/request'

/**
 * 查询第三方软件
 * @param {Object} params 
 * @returns 
 */
export function listThirdPartySoft(params) {
  return request({
    url: '/course/thirdPartySoft/list',
    method: 'GET',
    params,
  })
}

/**
 * 添加第三方软件
 * @param {Object} data 
 * @returns 
 */
export function addThirdPartySoft(data) {
  return request({
    url: '/course/thirdPartySoft/insert',
    method: 'POST',
    data,
  })
}

/**
 * 发布第三方软件
 * @param {Object} data 
 * @returns 
 */
export function publishThirdPartySoft(data) {
  return request({
    url: '/course/thirdPartySoft/publish',
    method: 'POST',
    data,
  })
}

/**
 * 更新第三方软件版本
 * @param {Object} data 
 * @returns 
 */
export function updateThirdPartySoftVersion(data) {
  return request({
    url: '/course/thirdPartySoft/updateCurrentVersion',
    method: 'POST',
    data,
  })
}

/**
 * 修改第三方软件
 * @returns 
 */
export function updateThirdPartySoft(data) {
  return request({
    url: '/course/thirdPartySoft/update',
    method: 'post',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function delThirdPartySoft(data) {
  return request({
    url: '/course/thirdPartySoft/remove',
    method: 'post',
    data,
  })
}


/**
 * 根据第三方软件id查询第三方软件信息
 * @param {Object} data
 * @returns 
 */
export function getThirdPartySoftById(params) {
  return request({
    url: '/course/thirdPartySoft/findById',
    method: 'get',
    params,
  })
}

